import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import property from 'lodash/property';

import { stringInputSpec } from '../../lib/editing-configs';
import './ab-test-wrapper.less';

const ABTestWrapper = ({ builderLoaded, children, testName, variant }) => {
  if (builderLoaded) {
    return (
      <div className="testWrapper">
        <div className="testDetailsWrapper">
          <div className="testDetail">
            <span>Test Name</span>: {testName || '–'}
          </div>
          <div className="testDetail">
            <span>Variant Name</span>: {variant || '–'}
          </div>
        </div>
        <div className="scWrapper">
          <StructuredContent>{children}</StructuredContent>
        </div>
      </div>
    );
  }

  return (
    <StructuredContent>
      {{
        type: 'ABTest',
        version: '1.0.0',
        props: {
          children,
          testName,
          variant,
        },
      }}
    </StructuredContent>
  );
};

ABTestWrapper.propTypes = {
  builderLoaded: PropTypes.bool,
  children: PropTypes.node,
  testName: PropTypes.string,
  variant: PropTypes.string,
};

ABTestWrapper.defaultProps = {
  builderLoaded: false,
  children: null,
  testName: '',
  variant: '',
};

ABTestWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('testName', 'Test Name'),
    stringInputSpec('variant', 'Variant Name'),
  ];
};

ABTestWrapper.displayName = 'A/B Test';

ABTestWrapper.isContainer = true;

export default compose(
  connect(
    createSelector(property('builder.builderLoaded'), (builderLoaded) => ({
      builderLoaded,
    }))
  )
)(ABTestWrapper);
